import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import clsx from 'clsx';
import EditOrderModal from '../../EditOrderModal';
import { handleEditOrderModal } from '../../../reducers/uiSlice';
import {DataGrid} from '@material-ui/data-grid';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { RenderCellExpand } from "./RenderCellExpand";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 500, 
        width: '100%', 
        marginTop: "20px",
        "& .MuiDataGrid-columnsContainer": {
            backgroundColor: '#212121'
        },
        "& .MuiDataGrid-iconSeparator": {
            display: "none"
        },
        "& .MuiDataGrid-cellLeft": {
            textAlign: 'center'
        },
        "& .MuiDataGrid-colCellTitle": {
            marginLeft: '20px'
        },
        "& .MuiDataGrid-row.Mui-odd": {
            backgroundColor: "#303030"
        },
        "& .MuiDataGrid-row.Mui-even": {
            backgroundColor: "#424242"
        },
        '& .cell-style': {
            textAlign: 'center'
        },
    },
    countOrder: {
        marginRight: theme.spacing(1),
    },
    countStyle: {
        display: "inline-block !important", 
        marginRight: '5px' 
    },
    popover: {
        pointerEvents: 'none',
    }
}));

export default function DisplayRecords(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('complaint');

    const complaints = useSelector(state => state.complaintReducer)

    const [records, setRecords] = useState({});
    const [rows, setRows] = useState([]);
    const [rowsDisplay, setRowsDisplay] = useState([]);
    const [editOrderModalOpen, setEditOrderModalOpen] = useState(false);
    const [tno, setTno] = useState('');

    function handleEditModalClose() {
        setEditOrderModalOpen(false);
    }
    function handleEditOrderModalOpen(tno) {
        setTno(tno);
        setEditOrderModalOpen(true);
    }
    function handletSelection(selection) {
        rows.map((row) => {
            if(row.order_id + '' === selection + '') {                
                handleEditOrderModalOpen(row.extra_order_sn);
                dispatch(handleEditOrderModal({open: true}));
                return;
            }
        })
    }

    useEffect(() => {
        if(complaints.getAllComplaints) {
            setRecords(complaints.getAllComplaints.complaints);
            setRows(complaints.getAllComplaints.complaints);
            setRowsDisplay(complaints.getAllComplaints.complaints)
        }
    }, [complaints.getAllComplaints])
    useEffect(() => {
        if(props.branchId && records && !props.first) {
            const stats = complaints.getAllComplaints.city_stats;
            let exist = false;
            for(var i = 0; i < stats.length; i++) {
                if(stats[i].city + '' === props.branchId + '') {
                    const rate = 1000 * stats[i].count / stats[i].order_count;
                    props.handleComplaintRate(rate);
                    exist = true;
                    break;
                } else if(stats[i].city + '' === 'all' && props.branchId === -1) {
                    const rate = 1000 * stats[i].count / stats[i].order_count;
                    props.handleComplaintRate(rate);
                    exist = true;
                    break;
                }
            }
            if(!exist) {
                props.handleComplaintRate('');
            }
            if(props.branchId !== -1) {
                let rowsCurr = [];
                records.map((record) => {
                    if(record.warehouse === props.branchId) {
                        rowsCurr.push(record);
                    }
                })
                setRows(rowsCurr);
                setRowsDisplay(rowsCurr);
            } else {
                setRows(records);
                setRowsDisplay(records);
            }         
        } else {
            let numListCopy = props.numList;
            numListCopy.fill(0);
            props.handleNumList(numListCopy);
            setRows([]);     
            setRowsDisplay([]); 
            props.handleComplaintRate('');  
        }
    }, [props.branchId])
    useEffect(() => {       
        if(complaints.getAllComplaints.city_stats) {            
            const counts = complaints.getAllComplaints.city_stats;
            let numListCurr = props.numList;
            for(var i = 0; i < props.numList.length; i++) {
                numListCurr[i] = 0;
            }
            let exist = false;
            for(var i = 0; i < counts.length; i++) {
                if(counts[i].city + '' === props.branchId + '') {
                    const rate = 1000 * counts[i].count / counts[i].order_count;
                    props.handleComplaintRate(rate);
                    exist = true;
                    break;
                } else if(counts[i].city + '' === 'all' && props.branchId === -1) {
                    const rate = 1000 * counts[i].count / counts[i].order_count;
                    props.handleComplaintRate(rate);
                    exist = true;
                    break;
                }
            }
            if(!exist) {
                props.handleComplaintRate('');
            }
            if(!props.first) {
                counts.map((cityCount) => {
                    if(cityCount.city === 'all') {
                        numListCurr[0] = cityCount.count;
                    } else {
                        numListCurr[cityCount.city] = cityCount.count;
                    }
                })
            } else {
                numListCurr.fill(0);
                props.handleComplaintRate('');
            }
            props.handleNumList(numListCurr);                            
        }
    }, [complaints.getAllComplaints])
    useEffect(() => {
        if(props.change) {
            if(complaints.getAllComplaints.city_stats) {            
                const counts = complaints.getAllComplaints.city_stats;
                let numListCurr = props.numList;
                if(!props.first) {
                    counts.map((cityCount) => {
                        if(cityCount.city === 'all') {
                            numListCurr[0] = cityCount.count;
                        } else {
                            numListCurr[cityCount.city] = cityCount.count;
                        }
                    })
                } else {
                    numListCurr.fill(0);
                }
                props.handleNumList(numListCurr);                            
            }
        }
    }, [props.change])
    useEffect(() => {
        if(rows) {
            props.handleRows(rows);
        }       
    }, [rows])
    useEffect(() => {
        if(props.driverId && props.rowsTemp) {
            setRowsDisplay(props.rowsTemp);
        } else {
            setRowsDisplay(rows);
        }
    }, [props.driverId, props.rowsTemp])

    const columns = [
        {
            field: 'timestamp', 
            headerName: t('time'), 
            width: 200,
            headerAlign: 'center',
            type: 'date',
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss")
        },
        {
            field: 'area', 
            headerName: t('area_no'), 
            width: 200,
            headerAlign: 'center'
        },
        {
            field: 'extra_order_sn', 
            headerName: t('tno'), 
            width: 200,
            headerAlign: 'center'
        },
        {
            field: 'driver_name',
            headerName: t('driver_no'),
            width: 200,
            headerAlign: 'center'
        },
        {
            field: 'driver_count',
            headerName: t('complaint_num'),
            width: 200,
            headerAlign: 'center',
            type: 'number',
            cellClassName: () => clsx('cell-style'),
        },
        {
            field: 'note',
            headerName: t('description'),
            width: 200,
            headerAlign: 'center',
            renderCell: RenderCellExpand
        },
        {
            field: 'operator',
            headerName: t('customer_service'),
            width: 200,
            headerAlign: 'center'
        }
    ];

    const moment = require('moment');

    return (
        <Box className={classes.root}>
            <EditOrderModal 
                open={editOrderModalOpen} 
                tno={tno} 
                onClose={handleEditModalClose} 
                handleClose={handleEditModalClose} 
                byResendOrder={true} 
            />
            {
                rows.length > 0 && 
                <DataGrid
                    alignItems="center"
                    rows={rowsDisplay.map((row) => createRow(row))}
                    columns={columns}
                    pageSize={20}
                    onSelectionModelChange={(newSelection) => {
                        handletSelection(newSelection);
                    }}
                />
            }
        </Box>
    );

    function createRow({
        order_id,
        timestamp,
        area,
        extra_order_sn,
        driver_name,
        driver_count,
        note,
        operator
    }) {
        let id = order_id;
        return {
            id,
            timestamp,
            area,
            extra_order_sn,
            driver_name,
            driver_count,
            note,
            operator
        };
    }
}
